// Sidebar.tsx

import React, { useState } from "react";
import { styled } from "@mui/system";
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Collapse } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { AppLogo } from "../Helpers/constants";
import s from "./layouts_style.module.css";
import menu_items_arr from "../Helpers/menu_items";
import { useTranslation } from "react-i18next";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const drawerWidth = 280;

const StyledRoot = styled('div')({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
});

const StyledDrawer = styled(Drawer)({
  width: drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerWidth,
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
});

const NestedListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingLeft: theme.spacing(6),
}));

const StyledListItemButton = styled(ListItemButton)({
  margin: "0 auto",
  color: "#4D67EB"
});

const Sidebar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  const handleClick = (itemName: string, path: string) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [itemName]: !prevState[itemName],
    }));
    navigate(path);
  };

  return (
    <StyledRoot>
      <StyledDrawer
        variant="permanent"
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <AppLogo />
          </div>
          <List
            style={{
              padding: "10px",
            }}
          >
            {menu_items_arr.map((item, index) => {
              const Icon = item.icon;
              const isExpandable = !!item.subItems;
              const isOpen = openItems[item.name];
              if (isExpandable) {
                return (
                  <React.Fragment key={index + item.name}>
                    <StyledListItemButton
                      onClick={() => handleClick(item.name, item.path)} // Pass path
                    >
                      <ListItemIcon>
                        <Icon />
                      </ListItemIcon>
                      <ListItemText
                        primary={t(`menu.${item.name}`, item.name)}
                      />
                      {isOpen ? <ExpandLess /> : <ExpandMore />}
                    </StyledListItemButton>
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.subItems?.map((subItem, subIndex) => {
                          return (
                            <NavLink
                              key={subIndex + subItem.path}
                              to={subItem.path}
                              className={({ isActive }) =>
                                isActive ? s.activeItem : s.navLinkItem
                              }
                              style={{ textDecoration: "none", color: "inherit" }} // Ensure no underline and inherit color
                            >
                              <div className={s.navLinkItemDiv}>
                                <NestedListItemButton
                                  sx={{ margin: "0 auto", color: "#4D67EB" }}
                                >
                                  <ListItemText
                                    primary={t(
                                      `menu.${subItem.name}`,
                                      subItem.name
                                    )}
                                  />
                                </NestedListItemButton>
                              </div>
                            </NavLink>
                          );
                        })}
                      </List>
                    </Collapse>
                  </React.Fragment>
                );
              } else {
                return (
                  <NavLink
                    key={index + item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      isActive ? s.activeItem : s.navLinkItem
                    }
                    style={{ textDecoration: "none", color: "inherit" }} // Ensure no underline and inherit color
                  >
                    <div className={s.navLinkItemDiv}>
                      <StyledListItemButton>
                        <ListItemIcon>
                          <Icon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t(`menu.${item.name}`, item.name)}
                        />
                      </StyledListItemButton>
                    </div>
                  </NavLink>
                );
              }
            })}
          </List>
        </div>
      </StyledDrawer>
    </StyledRoot>
  );
};

export default Sidebar;